module.exports = __webpack_public_path__ + "media/images/partner/pic_7@2x-729092c09570a6fb5dccc0a412ee7371.png";